import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { get } from '@/utils/ajax'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  linkActiveClass: 'link-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/works',
      name: 'works',
      redirect: '/works/list',
      component: () =>
        import('@/views/works/Index' /* webpackChunkName: "works" */),
      children: [
        {
          path: 'list',
          name: 'worksList',
          meta: {
            layout: 'main',
            title: '我的作品',
            needLogin: true
          },
          component: () =>
            import('@/views/works/List' /* webpackChunkName: "worksList" */)
        },
        {
          path: 'report',
          name: 'worksReport',
          meta: {
            layout: 'main',
            title: '作品报告',
            needLogin: true
          },
          component: () =>
            import(
              '@/views/works/Report' /* webpackChunkName: "worksReport" */
            )
        },
        {
          path: '*',
          redirect: '/works/list'
        }
      ]
    },
    {
      path: '/work_detail',
      name: 'workDetail',
      meta: {
        layout: 'minor',
        title: '作品详情',
        needLogin: true
      },
      component: () =>
        import('@/views/works/Detail' /* webpackChunkName: "workDetail" */)
    },
    {
      path: '/course',
      name: 'course',
      meta: {
        layout: 'main',
        title: '我的课程',
        needLogin: true
      },
      component: () =>
        import('@/views/course/List' /* webpackChunkName: "course" */)
    },
    {
      path: '/course_pack',
      name: 'coursePack',
      meta: {
        layout: 'minor',
        title: '课程包详情',
        needLogin: true
      },
      component: () =>
        import('@/views/course/Pack' /* webpackChunkName: "coursePack" */)
    },
    {
      path: '/course_detail',
      name: 'courseDetail',
      meta: {
        layout: 'minor',
        title: '课程详情',
        needLogin: true
      },
      component: () =>
        import('@/views/course/Detail' /* webpackChunkName: "courseDetail" */)
    },
    {
      path: '/report',
      name: 'report',
      redirect: '/report/study',
      component: () =>
        import('@/views/report/Index' /* webpackChunkName: "report" */),
      children: [
        {
          path: 'study',
          name: 'reportStudy',
          meta: {
            layout: 'main',
            title: '学习数据',
            needLogin: true
          },
          component: () =>
            import('@/views/report/Study' /* webpackChunkName: "study" */)
        },
        {
          path: 'growthFile',
          name: 'reportGrowthFile',
          meta: {
            layout: 'main',
            title: '成长档案',
            needLogin: true
          },
          component: () =>
            import(
              '@/views/report/GrowthFile' /* webpackChunkName: "growthFile" */
            )
        },
        {
          path: '*',
          redirect: '/report/study'
        }
      ]
    },
    {
      path: '/viewGrowthFile',
      name: 'viewGrowthFile',
      component: () =>
        import(
          '@/views/report/viewGrowthFile' /* webpackChunkName: "viewGrowthFile" */
        )
    },
    {
      path: '/viewer',
      name: 'viewer',
      component: () =>
        import('@/views/Viewer' /* webpackChunkName: "viewer" */)
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        layout: 'minor',
        title: '点猫编程平台'
      },
      component: () => import('@/views/Login' /* webpackChunkName: "login" */)
    },
    {
      path: '/phone',
      name: 'phone',
      meta: {
        layout: 'minor',
        title: '点猫编程平台',
        needLogin: true
      },
      component: () => import('@/views/Phone' /* webpackChunkName: "phone" */)
    },
    {
      path: '/user',
      name: 'user',
      meta: {
        layout: 'main',
        title: '我的',
        needLogin: true
      },
      component: () => import('@/views/User' /* webpackChunkName: "user" */)
    },
    {
      path: '/AIClassEvaluate',
      name: 'AIClassEvaluate',
      meta: {
        layout: 'noop',
        title: 'AI双师班级评价详情'
      },
      component: () =>
        import(
          '@/views/AIClassEvaluate' /* webpackChunkName: "AIClassEvaluate" */
        )
    },
    {
      path: '/AIStudentEvaluate',
      name: 'AIStudentEvaluate',
      meta: {
        layout: 'noop',
        title: 'AI双师学生评价详情'
      },
      component: () =>
        import(
          '@/views/AIStudentEvaluate' /* webpackChunkName: "AIStudentEvaluate" */
        )
    },
    {
      path: '*',
      component: () => import('@/Error' /* webpackChunkName: "error" */)
    }
  ]
})

// 登录态判断
// router.beforeEach(async (to, from, next) => {
//   if (to.meta.needLogin && !store.state.hasToken) {
//     try {
//       await Vue.prototype.$auth("get_access_token");
//       store.commit("HAS_TOKEN", true);
//     } catch (error) {
//       if (store.state.isWeixin) {
//         window.wxAuth();
//       } else {
//         return next({ name: "login" });
//       }
//     }
//   }
//   next();
// });

// 是否有教室权限判断及获取B端基础信息并跳转对应的端
router.beforeEach(async (to, from, next) => {
  if (to.meta.needLogin && !store.state.isOpen) {
    try {
      const res = await get('/api/home/account')
      const user = await get('/edu/zone')
      if (!res.is_open) {
        await Vue.prototype.$auth('logout')
        if (store.state.isWeixin) {
          window.wxAuth()
        } else {
          next({ name: 'login' })
        }
        return Vue.prototype.$message.error('该用户还未开通点猫编程平台')
      }
      store.commit('IS_OPEN', true)
      store.commit('SET_USER', res)
      store.commit('SET_USER', user)
    } catch (err) {
      await Vue.prototype.$auth('logout')
      next({ name: 'login' })
    }
  }
  next()
})

// 是否绑定了家长手机号
router.beforeEach(async (to, from, next) => {
  if (to.meta.needLogin && !store.state.hasParentPhone) {
    const { parent_mobile } = await store.dispatch('getClassUserInfo')
    if (!parent_mobile) {
      await Vue.prototype.$auth('logout')
      if (store.state.isWeixin) {
        window.wxAuth()
      } else {
        next({ name: 'login' })
      }
      return Vue.prototype.$message.error('该用户还未绑定家长手机号')
    }
    store.commit('HAS_PARENT_PHONE', true)
  }
  next()
})

// 学院移动端跳转过来
router.beforeEach((to, from, next) => {
  if (to.query.fromSchool) {
    store.commit('SET_FROM_SCHOOL', true)
    return next()
  }
  next()
})

export default router
